import { Component, OnInit } from '@angular/core';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent implements OnInit {
  resValue:any;

  contactTab: string='call';

  constructor(private util: UtilService) { }
  ngOnInit(): void {
    this.resValue = this.util.rmDetails.find((data:any)=> data.name === 'Customer Support');
  }

  goTohome() {
    this.util.route('home');
  }

}
